/**
 * AugustCrownPromoCard — Iter 339 · Feb 2026
 * ─────────────────────────────────────────
 * Slim time-sensitive promo card that renders directly under the
 * homepage hero to advertise the Crown Rewards Members $75 Laser
 * Genesis + Lymphatic Drainage combo (Ottawa, Tanya Shatenko).
 *
 * Auto-hides outside August so the homepage stays clean the rest of
 * the year. Deep-links to /promo/laser-genesis-lymphatic (Sept 2026 · was
 * /promo/laser-genesis-lymphatic-august · now retired as a redirect)
 * where the funnel wiring (sessionStorage + query params) takes over.
 */
import { Link } from "react-router-dom";
import { Crown, Sparkles, ArrowRight, MapPin } from "lucide-react";

// Feb 2026 — always visible until Karine deactivates. Toggle to
// `new Date().getMonth() === 7` (0-indexed → 7 = August) once the
// campaign is time-bound.
const IS_ACTIVE = true;

export default function AugustCrownPromoCard() {
  if (!IS_ACTIVE) return null;
  return (
    <section
      className="max-w-6xl mx-auto px-4 -mt-2 md:mt-0 md:px-6 py-6"
      data-testid="august-crown-promo-card"
    >
      <Link
        to="/promo/laser-genesis-lymphatic"
        data-testid="august-crown-promo-link"
        className="block rounded-2xl overflow-hidden shadow-2xl border-2 border-amber-500/70 hover:border-amber-500 transition-all bg-gradient-to-r from-amber-950 via-zinc-900 to-amber-950 hover:scale-[1.005]"
      >
        <div className="grid md:grid-cols-[1fr_auto] gap-4 items-center px-5 md:px-8 py-5">
          <div className="text-white space-y-2">
            <div className="inline-flex items-center gap-1.5 bg-emerald-500/20 text-emerald-300 rounded-full px-2.5 py-0.5 text-[10px] uppercase tracking-widest font-black">
              <Sparkles className="w-3 h-3" /> Crown Rewards · Fall &amp; Winter
            </div>
            <h2 className="font-serif text-xl md:text-2xl leading-tight text-amber-100">
              Laser Genesis + Lymphatic Facial Drainage
            </h2>
            <p className="text-sm text-zinc-300">
              <span className="line-through text-zinc-500">$275</span>
              <span className="text-amber-300 font-black text-2xl mx-2">$75</span>
              <span className="text-xs">+ tax · Members only</span>
            </p>
            <p className="text-xs text-zinc-400 flex items-center gap-1.5">
              <MapPin className="w-3 h-3" /> Ottawa · With one of our medical aestheticians
            </p>
          </div>
          <div className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-amber-950 font-black rounded-xl px-5 py-3 justify-self-start md:justify-self-end">
            <Crown className="w-4 h-4" />
            <span>See offer</span>
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </Link>
    </section>
  );
}
